import {useCallback, useEffect, useRef} from "react"
import {useIntl} from "react-intl"


export function useFamiliesAnnounce(from: string, familiesEnabled: boolean, restoredSession: boolean) {
    const intl = useIntl()
    const familiesAnnounceDone = useRef(false)

    const dismissFamiliesAnnounce = useCallback(() => {
        const el = document.querySelector(`.families-announce-${intl.locale}`)
        if (el) {
            familiesAnnounceDone.current = true
            el.classList.add("families-announce-dismiss")
            setTimeout(() => el.remove(), 500)
        }
    }, [intl.locale])

    useEffect(() => {
        if (familiesEnabled && !from && !familiesAnnounceDone.current && !restoredSession) {
            const menu = document.querySelector(".creator-tabs")
            const el = document.createElement("div")
            el.textContent = "👈 " + intl.formatMessage({id: "creator.families.announce"})
            el.className = `families-announce families-announce-${intl.locale}`
            menu?.appendChild(el)
        }
        return () => dismissFamiliesAnnounce()
    }, [from, familiesEnabled, restoredSession, intl, dismissFamiliesAnnounce])

    return dismissFamiliesAnnounce
}
